function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { createElementObject, createLayerComponent, extendContext, updateMediaOverlay } from "@manifesto-tech/react-leaflet-core";
import { VideoOverlay as LeafletVideoOverlay } from "leaflet";
export var VideoOverlay = createLayerComponent(function createVideoOverlay(_param, ctx) {
    var bounds = _param.bounds, url = _param.url, options = _objectWithoutProperties(_param, [
        "bounds",
        "url"
    ]);
    var overlay = new LeafletVideoOverlay(url, bounds, options);
    if (options.play === true) {
        var _overlay_getElement;
        (_overlay_getElement = overlay.getElement()) === null || _overlay_getElement === void 0 ? void 0 : _overlay_getElement.play();
    }
    return createElementObject(overlay, extendContext(ctx, {
        overlayContainer: overlay
    }));
}, function updateVideoOverlay(overlay, props, prevProps) {
    updateMediaOverlay(overlay, props, prevProps);
    if (typeof props.url === "string" && props.url !== prevProps.url) {
        overlay.setUrl(props.url);
    }
    var video = overlay.getElement();
    if (video != null) {
        if (props.play === true && !prevProps.play) {
            video.play();
        } else if (!props.play && prevProps.play === true) {
            video.pause();
        }
    }
});
